import { Repository } from "src/firebase/firestore/repository";
import { AiSessionTopic } from "../types/ai-session.entity";

class AISessionTopicRepository extends Repository<AiSessionTopic> {
  constructor() {
    super("ai_sessions_topics");
  }

  async find(args: any): Promise<(AiSessionTopic & { id: string })[]> {
    return await super.find(args) as (AiSessionTopic & { id: string })[];
  }
}

export const aiSessionTopicRepository = new AISessionTopicRepository();
